import React from 'react';
import { Loader2 } from 'lucide-react';
interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'white' | 'gray';
  className?: string;
}
const sizeMap = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12'
};
const colorMap = {
  primary: 'text-blue-600',
  white: 'text-white',
  gray: 'text-gray-400'
};
export function LoadingSpinner({
  size = 'md',
  color = 'primary',
  className = ''
}: LoadingSpinnerProps) {
  return <Loader2 className={`animate-spin ${sizeMap[size]} ${colorMap[color]} ${className}`} aria-label="Loading" data-id="element-967" />;
}
interface LoadingOverlayProps {
  message?: string;
}
export function LoadingOverlay({
  message = 'Loading...'
}: LoadingOverlayProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-968">
            <div className="bg-white rounded-lg p-8 flex flex-col items-center gap-4 shadow-2xl" data-id="element-969">
                <LoadingSpinner size="xl" data-id="element-970" />
                <p className="text-gray-700 font-medium" data-id="element-971">{message}</p>
            </div>
        </div>;
}
interface LoadingSkeletonProps {
  className?: string;
}
export function LoadingSkeleton({
  className = ''
}: LoadingSkeletonProps) {
  return <div className={`animate-pulse bg-gray-200 rounded ${className}`} data-id="element-972" />;
}